"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _navigationHelpers = require("../../helpers/navigationHelpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ListItem = function ListItemComponent(_ref) {
  var url = _ref.url,
      name = _ref.name,
      tabIndex = _ref.tabIndex;
  var linkClasses = (0, _classnames["default"])({
    'nav-drawer__link': true,
    'nav-drawer__link--active': (0, _navigationHelpers.isActiveNavItem)(url)
  });
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "nav-drawer__link-list__item"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    className: linkClasses,
    tabIndex: tabIndex
  }, name));
};

ListItem.propTypes = {
  url: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  tabIndex: _propTypes["default"].string.isRequired
};
var _default = ListItem;
exports["default"] = _default;